/**
 * Description: 系统消息样式
 * User: 常胤 <satans17@gmail.com>
 * Date: 15/3/28
 * Copyright(c) 2014 Taobao.com
 */

import $ from '@ali/tarzan-zepto';
import BaseUI from '../../../component/baseui/index';
import './style.scss';

export default function system(data) {
  let aniStyle = '';
  // 区分普通系统消息和卡片式系统消息的动效...
  if (data.isWide) {
    aniStyle = 'board';
  } else {
    aniStyle = data.position || 'center';
  }
  const aniClass = data.removeAni ? '' : `bubble-up-from-${aniStyle}`;
  const param = {
    name: 'system',
    side: `center ${aniClass}`,
    mid: data.mid,
    content: data.text,
  };
  const $node = $(BaseUI.msg(param));
  // 强调状态，有背景色
  if (data.isEm) {
    $node.addClass('m-chatpanel-system-em');
  }
  // 显示在左边or中间
  if (data.position) {
    $node.addClass(`m-chatpanel-system-${data.position}`);
  }
  // 加宽版
  if (data.isWide) {
    $node.addClass('m-chatpanel-system-wide');
  }
  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/system/index.js